/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import React, { CSSProperties } from 'react'
import { color } from '../../utils/Style'

export type BaseContainerProps = {
  children: React.ReactNode
  style?: CSSProperties
}

export const BaseContainer = ({ children, ...props }: BaseContainerProps) => {
  return (
    <div css={baseContainerStyle} {...props}>
      {children}
    </div>
  )
}

const baseContainerStyle = css`
  background-color: #f9f8f6;
  color: ${color.colorBlack};
  font-size: 14px;
  line-height: 160%;
  & a {
    text-decoration: none;
  }
`
